import styled from 'styled-components';
import { semanticColors } from 'styles/colors';
import { headline, paragraph } from 'styles/types';
import { borderRadius, space } from 'styles/variables';
import { Button } from '@chownow/cn-web-components';

export const MissingDetailsContainer = styled.div`
  padding-top: ${space.x12};
`;

export const MissingDetailsHeading = styled.h2`
    font: ${headline.md.x32};
`;

export const MissingDetailsSubhead = styled.p`
  font: ${paragraph.reg.x14};
  margin: ${space.x2} 0 0 0;
`;

export const DetailsContainer = styled.ul`
  background-color: ${semanticColors.surface.primary};
  border: 1px solid ${semanticColors.border.primary};
  border-radius: ${borderRadius.small};
  display: flex;
  flex-direction: column;
  margin-top: ${space.x5};
  padding: ${space.x1} ${space.x2};
`;

export const Step = styled.li`
  &:not(:last-child) {
    border-bottom: 1px solid ${semanticColors.surface.tertiary};
  }
`;

export const StyledButton = styled(Button)`
  margin: ${space.x5} auto ${space.x5} auto;
`;
